module.exports = __webpack_public_path__ + "img/blank.e3370306.png";